<template>
  <div class="componentRoot" :style="{ width: profileView ? 'unset' : '100vw',   }" style="overflow: hidden; flex-grow: 1">
    <v-container fluid v-if="!profileView" class="py-0" :class="{}">
      <v-row>
        <v-col style="position: relative">
          <img src="/images/main/shopBanner.jpg" :style="{
            height: imageHeight
          }" style="
                        width: 100vh; 
                        object-fit: cover; 
                        width: 100%;
                        object-position: top;" />

          <div style="position:absolute; top: 50%; transform: translate(0, -50%);"
            :style="{ 'max-width': maxBannerWidth, 'left': bannerOffset }">
            <p style="color: white" v-html="$t('titleScreens.bannerText')"></p>
            <h1 style="color: white" class="mb-4" v-html="$t('titleScreens.shop')"></h1>
            <a :href="$getPhoneLink()">
              <v-btn flat class="primaryButton mt-4 rounded-xl">{{ $t("landing.contactText2")
              }}</v-btn>
            </a><br>
            <small style="color:rgb(var(--v-theme-light))" class="ml-4">{{ $t("landing.contactButtonText")
            }}</small>
          </div>
        </v-col>
      </v-row>


      <WaveVue :color="'rgb(var(--v-theme-background))'" :negative="true"
        :style="{ 'margin-top': isMobile ? '-78px' : '-138px' }" :height="isMobile ? 60 : 120"
        style="z-index: 2; position: relative;" />

    </v-container>

    <v-container :fluid="profileView || $vuetify.display && $vuetify.display.width < 1920">
      <v-row :class="{'mx-2': !landing}">
        <v-spacer v-if="!profileView" />
        <v-col :cols="isMobile ? 12 : 10" :style="{ 'margin-left': marginLeftOffset }">
          <h2>{{ $t("landing.myServices") }}</h2>
          <p>{{ $t("landing.myServicesShopText") }}</p>
        </v-col>
        <v-spacer />

        <v-col cols="auto" class="pr-8" style="display: flex; align-items: center;
            align-content: center; position: relative;"  v-if="profileView" @click="() => { this.shoppingCartDrawer++ }">
          <div style=" position: relative;">
            <v-btn :class="{primaryButton: activeCart}" flat>
            <v-icon class="headerNav">mdi-cart</v-icon> {{ $t("basics.shoppingCart") }}
            </v-btn>
          </div>
        </v-col>
      </v-row>

      <v-row>
        <v-spacer v-if="!profileView" />
        <v-col :cols="mainCols">
          <v-card class="mx-4" :style="{'background-color': !landing ? 'rgb(var(--v-theme-background)) !important' : undefined}">
            <v-container fluid >
              <v-row>
                <v-slide-group v-model="selectedProductType" mandatory style="width: 100%">
                  <v-slide-group-item value="all" v-slot="{ isSelected, toggle }">
                    <v-btn flat :color="isSelected ? 'primary' : (landing ? '' : 'background')"
                    :style="{color: isSelected ? 'rgb(var(--v-theme-light)) !important' : ''}"
                      class="rounded-lg mr-2 text-center hoverable" @click="toggle"
                      style="min-width: fit-content; flex-grow: 1">
                      {{ $t("basics.all") }}
                    </v-btn>
                  </v-slide-group-item>
                  <v-slide-group-item v-for="pt in productTypes" :key="pt.id" :value="String(pt.id)"
                    v-slot="{ isSelected, toggle }">
                    <v-btn flat :color="isSelected ? 'primary' : (landing ? '' : 'background')"
                    :style="{color: isSelected ? 'rgb(var(--v-theme-light)) !important' : ''}"
                      class="rounded-lg mr-2 text-center hoverable" @click="toggle"
                      style="min-width: fit-content; flex-grow: 1">
                      {{ pt.name }}
                    </v-btn>
                  </v-slide-group-item>
                </v-slide-group>
              </v-row>
            </v-container>
          </v-card>

          <v-card class="my-4 mx-4"  :style="{'background-color': !landing ? 'rgb(var(--v-theme-background)) !important' : undefined}">
            <v-container fluid>
              <v-row>
                <v-slide-group v-model="selectedContentType" mandatory style="width: 100%">
                  <v-slide-group-item value="all" v-slot="{ isSelected, toggle }" class="mx-4">
                    <v-btn flat block :color="isSelected ? 'primary' : (landing ? '' : 'background')"
                    :style="{color: isSelected ? 'rgb(var(--v-theme-light)) !important' : ''}"
                      class="rounded-lg text-center hoverable" @click="toggle"
                      style="min-width: fit-content; flex-grow: 1"
                      >
                      {{ $t("basics.all") }}
                    </v-btn>
                  </v-slide-group-item>
                  <v-slide-group-item v-for="contentType in contentTypes" :key="contentType.value"  class="mx-4"
                    :value="contentType.value" v-slot="{ isSelected, toggle }">
                    <v-btn 
                    flat block :color="isSelected ? 'primary' : (landing ? '' : 'background')" 
                    :style="{color: isSelected ? 'rgb(var(--v-theme-light)) !important' : ''}"
                      class="rounded-lg mr-2 text-center hoverable" @click="toggle"
                      style="min-width: fit-content; flex-grow: 1">
                      {{ $t(contentType.label) }}
                    </v-btn>
                  </v-slide-group-item>
                </v-slide-group>
              </v-row>
            </v-container>
          </v-card>

          <v-alert v-if="purchaseStatusError" type="warning" variant="tonal" class="mb-4" role="alert">
            {{ $t('messages.purchaseStatusCheckFailed') }}
            <v-btn variant="text" :loading="checkingPurchaseStatus" @click="refreshPurchaseStatus">{{ $t('basics.checkAgain') }}</v-btn>
          </v-alert>

          <v-card v-if="digitalMedias || appointments" color="transparent">
            <v-container fluid>
              <v-row gap="10">
                <v-col cols="12" v-if="filteredDigitalMedias.length === 0 && filteredAppointments.length === 0 && filteredDigitalBundles.length === 0"
                  style="text-align: center">
                  {{ $t("messages.noItems") }}
                </v-col>
                <template v-else>
                  <v-col :cols="cardCols" v-for="(a, aIndex) in filteredAppointments" :key="`appointment-${a.id ?? aIndex}`"
                    :style="{ order: isPurchaseBlocked(a, 'appointment') ? 1 : 0 }"
                    style="display: flex; flex-direction: column; ">
                    <div :class="{ 'shop-item-blocked': isPurchaseBlocked(a, 'appointment') }" :style="{ 'border': profileView ? '1px solid rgba(var(--v-theme-on-surface), 0.4)' : '' }"
                      style="display: flex; flex-direction: column; flex-grow: 1; border-radius: 12px !important;">
                      <img :src="getProductTypeUrl(a)"
                        :alt="$t('messages.publicAppointmentImage', { type: a.product?.name })" style="
                        border-radius: 12px 12px 0 0;
                        width: 100%;
                        aspect-ratio: 16/9;
                        object-fit: cover;
                      " />
                      <div class="pa-5" style="
                    display: flex; flex-direction: column; flex-grow: 1 !important; 
                    background-color: rgb(var(--v-theme-light));
                    border-bottom-right-radius: 12px!important;
                    border-bottom-left-radius: 12px!important;
                    ">
                        <div class="my-3">
                          <!-- <v-chip color="primary" class="mr-2 mt-2" style="border-radius: 6px;">{{ (a.follow_ups?.length + 1) || 1
                        }} {{ $t("basics.appointment" + ((a.follow_ups.length + 1) == 1 ? '' : 's')) }}</v-chip> -->
                          <v-chip color="primary" class="mr-2 mt-2" style="border-radius: 6px;"
                            v-if="a.num_patients == 1">
                            <v-icon class="mr-1">mdi-account</v-icon>
                            {{ $t('basics.soloAppointment') }}</v-chip>
                          <v-chip color="primary" class="mr-2 mt-2" style="border-radius: 6px;" v-else>
                            <v-icon class="mr-1">mdi-account-multiple</v-icon>
                            {{ $t('basics.groupAppointment') }}</v-chip>

                          <v-chip color="blue" class="mr-2 mt-2" style="border-radius: 6px;"
                            v-if="a.display_location == 'online'">
                            <v-icon class="mr-1" color="blue">mdi-web</v-icon>
                            {{ $t('constants.locations_online') }}</v-chip>
                        </div>
                        <h3 style="font-weight: normal">{{ a.product.name }}</h3>
                        <p v-if="a.product?.description?.length > 150">{{ a.product?.description.substring(0, 147) }}...
                        </p>
                        <p v-else>{{ a.product?.description }}</p>
                        <div style="flex-grow: 1; min-height: 10px;"></div>

                        <v-row style="flex-grow: 1">
                          <v-col cols="auto" v-if="a.display_address" class="pr-0">
                            <v-icon class="icon-transparency">mdi-map-marker</v-icon>
                          </v-col>
                          <v-col>
                            {{ a.display_address }}
                          </v-col>
                        </v-row>

                        <v-row style="flex-grow: 0">
                          <v-col cols="auto" v-if="a.display_address" class="pr-0">
                            <v-icon class="icon-transparency">mdi-calendar</v-icon>
                          </v-col>
                          <v-col class="pr-0" style="display: flex">
                            {{ a.display_date }}<span v-if="a.follow_ups && a.follow_ups.length > 0"
                              style="padding-right: 4px">, </span>
                            <div class="pr-0" v-for="(date, dateIndex) in a.follow_ups">
                              {{ date.display_date }}<span v-if="dateIndex < a.follow_ups.length - 1"
                                style="padding-right: 4px">, </span>
                            </div>
                          </v-col>
                        </v-row>

                        <v-row style="flex-grow: 0">
                          <v-col cols="auto" v-if="a.display_address" class="pr-0">
                            <v-icon class="icon-transparency">mdi-account-multiple</v-icon>
                          </v-col>
                          <v-col>
                            {{ $t("messages.availSlots", {
                              free: a.num_patients - a.num_blocked, total: a.num_patients
                            })
                            }}
                          </v-col>
                        </v-row>

                        <p v-if="isPurchaseBlocked(a, 'appointment')" class="shop-item-status" role="status">
                          <v-icon size="small">mdi-check-circle-outline</v-icon>
                          {{ purchaseMessage(a, 'appointment') }}
                        </p>
                        <v-row style="display: flex; align-items: end; flex-grow: 0" class="pt-2">
                          <v-col>
                            <h3 style="color: rgb(var(--v-theme-primary)); font-weight: normal;">{{ a.product.price }}€
                            </h3>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="auto">
                            <v-btn :class="{ primaryButton: !isPurchaseBlocked(a, 'appointment') }"
                              :disabled="purchaseUnavailable(a, 'appointment')" @click="addToCart(a)">
                              {{ isPurchaseBlocked(a, 'appointment') ? $t('basics.notPurchasable') : $t("basics.add") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-col>

                  <v-col :cols="cardCols" v-for="(dm, dmIndex) in filteredDigitalMedias" :key="`digitalmedia-${dm.id ?? dmIndex}`"
                    :style="{ order: isPurchaseBlocked(dm, 'digitalmedia') ? 1 : 0 }"
                    style="display: flex; flex-direction: column;">
                    <div :class="{ 'shop-item-blocked': isPurchaseBlocked(dm, 'digitalmedia') }" :style="{ 'border': profileView ? '1px solid rgba(var(--v-theme-on-surface), 0.4)' : '' }"
                      style="display: flex; flex-direction: column; flex-grow: 1; border-radius: 12px !important;">
                      <img :src="dm.banner_image_64 ? dm.banner_image_64 : '/images/main/background.jpeg'"
                        :alt="$t('messages.digitalMediaImage')" style="
                        border-radius: 12px 12px 0 0;
                        width: 100%;
                        aspect-ratio: 16/9;
                        object-fit: cover;
                      " />
                      <div class="pa-5" style="
                    display: flex; flex-direction: column; flex-grow: 1!important; 
                    background-color: rgb(var(--v-theme-light));
                    border-bottom-right-radius: 12px!important;
                    border-bottom-left-radius: 12px!important;
                    ">
                        <div class="my-3">
                          <v-chip v-for="(ft, index) in dm.tags" :key="ft.id ?? index" color="primary" class="mr-2 mt-2"
                            style="border-radius: 6px;">{{ ft.name }}</v-chip>
                        </div>
                        <h3 style="font-weight: normal">{{ dm.name }}</h3> <small v-if="dm.duration">{{ $t('messages.digitalMediaDuration', { minutes: dm.duration }) }}</small>
                        <p v-if="dm.description && dm.description.length > 150">{{ dm.description.substring(0, 147) }}...</p>
                        <p v-else>{{ dm.description }}</p>
                        <div style="flex-grow: 1; min-height: 10px;"></div>
                        <p v-if="isPurchaseBlocked(dm, 'digitalmedia')" class="shop-item-status" role="status">
                          <v-icon size="small">mdi-check-circle-outline</v-icon>
                          {{ purchaseMessage(dm, 'digitalmedia') }}
                        </p>
                        <v-row style="display: flex; align-items: end;" class="pt-2">
                          <v-col>
                            <h3 style="color: rgb(var(--v-theme-primary)); font-weight: normal;">{{ isFreeDigital(dm, "digitalmedia") ? $t("basics.freeOfCharge") : dm.price + "€" }}
                              <span v-if="dm.is_subscription && !isFreeDigital(dm, 'digitalmedia')">
                                / {{ $t("basics.month") }}
                              </span>
                            </h3>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="auto">
                            <v-btn :class="{ primaryButton: !isPurchaseBlocked(dm, 'digitalmedia') }"
                              :disabled="subscriptionCheckout !== null || purchaseUnavailable(dm, 'digitalmedia')"
                              :loading="subscriptionCheckout === `digitalmedia-${dm.id}`" @click="addToCart(dm)">
                              {{ isPurchaseBlocked(dm, 'digitalmedia') ? $t('basics.notPurchasable') : $t(dm.is_subscription && !isFreeDigital(dm, "digitalmedia") ? "messages.subscribe" : "basics.add") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-col>
                  <v-col :cols="cardCols" v-for="(bundle, bundleIndex) in filteredDigitalBundles" :key="`digitalbundle-${bundle.id ?? bundleIndex}`"
                    :style="{ order: isPurchaseBlocked(bundle, 'digitalbundle') ? 1 : 0 }"
                    style="display: flex; flex-direction: column;">
                    <div :class="{ 'shop-item-blocked': isPurchaseBlocked(bundle, 'digitalbundle') }" :style="{ 'border': profileView ? '1px solid rgba(var(--v-theme-on-surface), 0.4)' : '' }"
                      style="display: flex; flex-direction: column; flex-grow: 1; border-radius: 12px !important;">
                      <img :src="'/images/main/background.jpeg'"
                        :alt="$t('messages.digitalBundleImage', { name: bundle.name })" style="
                        border-radius: 12px 12px 0 0;
                        width: 100%;
                        aspect-ratio: 16/9;
                        object-fit: cover;
                      " />
                      <div class="pa-5" style="
                    display: flex; flex-direction: column; flex-grow: 1!important; 
                    background-color: rgb(var(--v-theme-light));
                    border-bottom-right-radius: 12px!important;
                    border-bottom-left-radius: 12px!important;
                    ">
                        <div class="my-3">
                          <v-chip color="primary" class="mr-2 mt-2">{{ $t('basics.digitalBundle') }}</v-chip>
                        </div>
                        <h3 style="font-weight: normal">{{ bundle.name }}</h3>
                        <div v-if="bundle.digital_medias && bundle.digital_medias.length" class="bundle-contents my-3">
                          <b>{{ $t('basics.digitalMedias') }}</b>
                          <ul class="pl-5 mt-1">
                            <li v-for="media in bundle.digital_medias" :key="media.id">{{ media.name }}</li>
                          </ul>
                        </div>
                        <p v-if="bundle.description && bundle.description.length > 150">{{ bundle.description.substring(0, 147) }}...</p>
                        <p v-else>{{ bundle.description }}</p>
                        <div style="flex-grow: 1; min-height: 10px;"></div>
                        <p v-if="isPurchaseBlocked(bundle, 'digitalbundle')" class="shop-item-status" role="status">
                          <v-icon size="small">mdi-check-circle-outline</v-icon>
                          {{ purchaseMessage(bundle, 'digitalbundle') }}
                        </p>
                        <v-row style="display: flex; align-items: end;" class="pt-2">
                          <v-col>
                            <h3 style="color: rgb(var(--v-theme-primary)); font-weight: normal;">{{ isFreeDigital(bundle, "digitalbundle") ? $t("basics.freeOfCharge") : bundle.price + "€" }}
                              <span v-if="bundle.is_subscription && !isFreeDigital(bundle, 'digitalbundle')">
                                / {{ $t("basics.month") }}
                              </span>
                            </h3>
                          </v-col>
                          <v-spacer></v-spacer>
                          <v-col cols="auto">
                            <v-btn :class="{ primaryButton: !isPurchaseBlocked(bundle, 'digitalbundle') }"
                              :disabled="subscriptionCheckout !== null || purchaseUnavailable(bundle, 'digitalbundle')"
                              :loading="subscriptionCheckout === `digitalbundle-${bundle.id}`" @click="addToCart(bundle, 'digitalbundle')">
                              {{ isPurchaseBlocked(bundle, 'digitalbundle') ? $t('basics.notPurchasable') : $t(bundle.is_subscription && !isFreeDigital(bundle, "digitalbundle") ? "messages.subscribe" : "basics.add") }}
                            </v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </v-col>
                </template>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <v-spacer v-if="!profileView" />
      </v-row>
    </v-container>

    <v-snackbar v-model="snackbarItem" color="primary" :timeout="2000" location="bottom right">
      <v-icon size="xx-large" color="light">mdi-cart</v-icon>
      <h3 style="color: rgb(var(--v-theme-light));">{{ $t("messages.itemAdded") }}</h3>
    </v-snackbar>

    <Teleport to="body">
      <ShoppingCartVue ref="shoppingCart" :refreshDisplay="shoppingCartDrawer" />
    </Teleport>

  </div>
</template>

<script>
import ShoppingCartVue from "../../components/shop/ShoppingCart.vue";

export default {
  name: "landingPageShopComponent",

  props: ["profileView"],

  data() {
    return {
      productTypes: [],
      selectedProductType: "all",
      selectedContentType: "all",
      contentTypes: [
        { value: "digitalmedia", label: "basics.digitalMedia" },
        { value: "digitalbundle", label: "basics.digitalBundle" },
        { value: "appointment", label: "basics.appointment" },
      ],
      purchaseStatus: {},
      checkingPurchaseStatus: false,
      purchaseStatusError: false,
      purchaseStatusRequest: 0,
      loading: false,
      digitalMedias: [],
      digitalBundles: [],
      appointments: [],

      snackbarItem: false,
      subscriptionCheckout: null,
      shoppingCartDrawer: false,
    };
  },

  components: {
    ShoppingCartVue
  },

  watch: {
    username() { this.refreshPurchaseStatus(); },
  },

  computed: {
    username() {
      return this.$store.state.name;
    },
    isMobile() {
      return ["xs", "sm"].includes(this.$vuetify.display.name);
    },

    filteredAppointments() {
      if (!["all", "appointment"].includes(this.selectedContentType)) return [];
      return this.appointments.filter(item => this.matchesProductType(item));
    },
    filteredDigitalMedias() {
      if (!["all", "digitalmedia"].includes(this.selectedContentType)) return [];
      return this.digitalMedias.filter(item => this.matchesProductType(item));
    },
    filteredDigitalBundles() {
      if (!["all", "digitalbundle"].includes(this.selectedContentType)) return [];
      return this.digitalBundles.filter(item => this.selectedProductType === "all" ||
        item.digital_medias.some(media => this.matchesProductType(media)));
    },
    activeCart(){
      return this.$store.state.shopping_cart_items && this.$store.state.shopping_cart_items.length > 0;
    },
    mainCols() {
      if (this.profileView || !this.landing) {
        return '12';
      }

      switch (this.$vuetify.display.name) {
        case "xs":
        case "sm":
        case "md":
        case "lg":
          return 10;
        case "xl":
          return 9;
        case "xxl":
        default:
          return 6;
      }
    },

    marginLeftOffset() {
      if (this.profileView) {
        return 0;
      }

      switch (this.$vuetify.display.name) {
        case "xs":
          return "12px";
        case "lg":
          return "100px";
        default:
          return "50px";
      }
    },

    imageHeight() {
      let windowHeight = this.$vuetify.display.height;
      let cutoffHeight = 500;

      switch (this.$vuetify.display.name) {
        case "xs":
        case "sm":
          return windowHeight * 0.8 > cutoffHeight
            ? "80vh"
            : cutoffHeight + "px";
        default:
          return windowHeight * 0.7 > cutoffHeight
            ? "70vh"
            : cutoffHeight + "px";
      }
    },

    maxBannerWidth() {
      switch (this.$vuetify.display.name) {
        case "xs":
        case "sm":
        case "md":
          return "90%";
        case "lg":
        case "xl":
          return "80%";
        case "xxl":
        default:
          return "60%";
      }
    },

    bannerOffset() {
      switch (this.$vuetify.display.name) {
        case "xs":
        case "sm":
        case "md":
        case "lg":
        case "xl":
          return "10%";
        case "xxl":
        default:
          return "15%";
      }
    },
    landing(){
      return this.$route.name == "landingpageShop"
    },
    cardCols() {
      
      switch (this.$vuetify.display.name) {
        case "xs": return 12;
        case "sm": return 6;
        case "md": return 4;
        case "lg": return 4;
        case "xl": return 4;
        case "xxl": return this.landing ? 4 : 3;
        default: return 3;
      }
    },
  },

  methods: {
    isFreeDigital(item, type) {
      return ["digitalmedia", "digitalbundle"].includes(type) &&
        item.price !== null && item.price !== undefined && item.price !== "" && Number(item.price) === 0;
    },
    purchaseKey(item, type) {
      return `${type}-${item.id}`;
    },
    isPurchaseBlocked(item, type) {
      return this.purchaseStatus[this.purchaseKey(item, type)]?.blocked === true;
    },
    purchaseMessage(item, type) {
      const status = this.purchaseStatus[this.purchaseKey(item, type)] || {};
      const translationKeys = {
        already_owned: 'messages.shopAlreadyOwned',
        checkout_pending: 'messages.shopCheckoutPending',
        subscription_exists: 'messages.shopSubscriptionExists',
        already_booked: 'messages.shopAlreadyBooked',
        not_available: 'messages.itemNotPurchasable',
      };
      return this.$t(translationKeys[status.code] || 'messages.itemNotPurchasable');
    },
    purchaseUnavailable(item, type) {
      return this.isPurchaseBlocked(item, type) ||
        (!!this.username && (this.loading || this.checkingPurchaseStatus || this.purchaseStatusError));
    },
    async refreshPurchaseStatus() {
      const requestId = ++this.purchaseStatusRequest;
      this.purchaseStatus = {};
      this.purchaseStatusError = false;
      this.checkingPurchaseStatus = false;
      if (!this.username) return;
      const references = new Map([
        ...this.appointments.map(item => ({ item_id: item.id, item_type: 'appointment' })),
        ...this.digitalMedias.map(item => ({ item_id: item.id, item_type: 'digitalmedia' })),
        ...this.digitalBundles.map(item => ({ item_id: item.id, item_type: 'digitalbundle' })),
      ].map(item => [`${item.item_type}-${item.item_id}`, item]));
      const items = [...references.values()];
      if (!items.length) return;
      this.checkingPurchaseStatus = true;
      try {
        const status = {};
        for (let start = 0; start < items.length; start += 100) {
          const batch = items.slice(start, start + 100);
          const response = await this.axios.post(
            this.axios.defaults.baseURL + 'media/payment/cart-status/',
            { line_items: batch }
          );
          if (requestId !== this.purchaseStatusRequest) return;
          if (!Array.isArray(response.data.items)) throw new Error(this.$t('messages.invalidPurchaseStatus'));
          for (const item of response.data.items) {
            status[`${item.item_type}-${item.item_id}`] = item;
          }
          if (batch.some(item => typeof status[`${item.item_type}-${item.item_id}`]?.blocked !== 'boolean')) {
            throw new Error(this.$t('messages.incompletePurchaseStatus'));
          }
        }
        if (requestId === this.purchaseStatusRequest) this.purchaseStatus = status;
      } catch (error) {
        if (requestId === this.purchaseStatusRequest) this.purchaseStatusError = true;
      } finally {
        if (requestId === this.purchaseStatusRequest) this.checkingPurchaseStatus = false;
      }
    },
    getProductTypeUrl(appointment) {
      console.log(appointment)
      if (appointment && appointment.product && appointment.product.type && appointment.product.type.thumbnail) {
        return this.axios.defaults.url + appointment.product.type.thumbnail
      }
    },
    async addToCart(item, explicitType) {
      const isAppointment = !!item.product;
      const itemType = explicitType || (isAppointment ? "appointment" : "digitalmedia");
      if (this.purchaseUnavailable(item, itemType)) return;
      const product = isAppointment ? item.product : item;

      const cartItem = {
        id: item.id,
        item_type: itemType,
        name: product.name,
        description: product.description,
        price: product.price,
        is_subscription: itemType === "digitalbundle" ? product.payment_type === 1 : (product.is_subscription ?? false),
        payment_type: product.payment_type,
      };

      if (itemType === "digitalbundle") {
        // Für die Warnung im Warenkorb, wenn ein enthaltenes Medium zusätzlich drin liegt.
        cartItem.digital_medias = (product.digital_medias || []).map(media =>
          media && typeof media === "object" ? media.id : media);
      }

      if (this.isFreeDigital(product, itemType)) {
        if (this.subscriptionCheckout !== null) return;
        this.subscriptionCheckout = `${itemType}-${item.id}`;
        try {
          const added = await this.$refs.shoppingCart.claimFreeItem(cartItem);
          if (added) this.snackbarItem = true;
          await this.refreshPurchaseStatus();
        } finally { this.subscriptionCheckout = null; }
        return;
      }

      if (isAppointment) {
        cartItem.num_patients = item.num_patients;

        // Kompatibel mit deinem bisherigen ShoppingCart-Drawer.
        cartItem.product = {
          name: product.name,
          description: product.description,
          price: product.price,
        };
      }

      if (!isAppointment && cartItem.is_subscription === true) {
        if (this.subscriptionCheckout !== null) return;
        this.subscriptionCheckout = `${cartItem.item_type}-${cartItem.id}`;
        try {
          await this.$refs.shoppingCart.goToCheckout([cartItem], `subscription-${cartItem.item_type}-${cartItem.id}`);
        } finally {
          this.subscriptionCheckout = null;
        }
        return;
      }

      const cart = (this.$store.state.shopping_cart_items || []).filter(entry =>
        !((entry.item_type || (entry.product ? "appointment" : "digitalmedia")) !== "appointment" &&
          entry.is_subscription === true)
      );

      if (
        cart.some(
          entry =>
            entry.id === cartItem.id &&
            (entry.item_type || (entry.product ? "appointment" : "digitalmedia")) ===
            cartItem.item_type
        )
      ) {
        return;
      }

      cart.push(cartItem);
      this.$store.dispatch("setShoppingCartItems", cart);
      this.snackbarItem = true;
    },

    matchesProductType(item) {
      if (this.selectedProductType === "all") return true;
      // Appointments: product.type; digital media: product.type or type.
      // Accept nested type objects as well as plain foreign-key IDs.
      const type = item.product?.type ?? item.type;
      const typeId = type && typeof type === "object" ? type.id : type;
      return typeId != null && String(typeId) === this.selectedProductType;
    },
    fetchCategories() {
      return new Promise((resolve, reject) => {
        this.axios
          .get(this.axios.defaults.baseURL + "media/producttypes/public/")
          .then((resp) => {
            this.productTypes = resp.data.results;




            resolve()

          })
          .catch((e) => {
            console.log(e);
            window.dispatchEvent(
              new CustomEvent("showErrorDisplay", { detail: e }),
            );
            reject()
          });
      })
    },
    fetchDigitalMedias() {
      return new Promise((resolve, reject) => {
        this.axios
          .get(this.axios.defaults.baseURL + "media/digitalmedias/public/")
          .then((resp) => {
            this.digitalMedias = resp.data.results;
            resolve()
          })
          .catch((e) => {
            console.log(e);
            window.dispatchEvent(
              new CustomEvent("showErrorDisplay", { detail: e }),
            );
            reject()
          });
      })
    },
    async fetchDigitalBundles() {
      try {
        const items = [];
        let url = this.axios.defaults.baseURL + "media/digitalbundles/public/";
        while (url) {
          const { data } = await this.axios.get(url);
          items.push(...(data.results ?? data));
          url = data.next || null;
        }
        this.digitalBundles = items;
      } catch (error) {
        window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: error }));
        throw error;
      }
    },
    async fetchData() {
      this.loading = true;
      try {
        await Promise.all([
          this.fetchCategories(),
          this.fetchDigitalMedias(),
          this.fetchDigitalBundles(),
          this.fetchAppointments(),
        ]);
      } catch (error) {
        // The fetch methods already display the request error.
      } finally {
        await this.refreshPurchaseStatus();
        this.loading = false;
      }
    },
    fetchAppointments() {
      return new Promise((resolve, reject) => {
        this.axios
          .get(this.axios.defaults.baseURL + "calendar/timeslots/public/")
          .then((resp) => {
            this.appointments = resp.data.results;
            resolve()
          })
          .catch((e) => {
            console.log(e);
            window.dispatchEvent(
              new CustomEvent("showErrorDisplay", { detail: e }),
            );
            reject()
          });
      })
    }
  },

  mounted() {
    this.fetchData();
    window.addEventListener('focus', this.refreshPurchaseStatus);
    window.addEventListener('digital-content-added', this.refreshPurchaseStatus);
  },

  beforeUnmount() {
    window.removeEventListener('focus', this.refreshPurchaseStatus);
    window.removeEventListener('digital-content-added', this.refreshPurchaseStatus);
    this.purchaseStatusRequest++;
  },
};
</script>

<style>
.selected {
  background-color: rgba(var(--v-theme-primary), 0.2) !important;
}
</style>

<style scoped>
.shop-item-blocked,
.shop-item-blocked > .pa-5 {
  background-color: #f2f2f2 !important;
  color: #616161;
}
.shop-item-blocked > img {
  filter: grayscale(1);
  opacity: 0.65;
}
.shop-item-status {
  margin-top: 12px;
  font-size: 0.875rem;
  color: #616161;
}
</style>
